var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$t('objects.report.liabilitySharePercent'),
      "readonly": _vm.readonly,
      "outlined": "",
      "type": "number",
      "rules": _vm.isRelativeValueRule,
      "clearable": ""
    },
    model: {
      value: _vm.value.liabilitySharePercent,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "liabilitySharePercent", _vm._n($$v));
      },
      expression: "value.liabilitySharePercent"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-select', {
    attrs: {
      "label": _vm.$t('objects.report.isDeductions'),
      "readonly": _vm.readonly,
      "items": [true, false],
      "outlined": "",
      "clearable": ""
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [_c('v-chip', {
          attrs: {
            "small": ""
          }
        }, [_vm._v(" " + _vm._s(_vm.$t("report.accidentDetails.location.".concat(item))) + " ")])];
      }
    }, {
      key: "item",
      fn: function fn(_ref2) {
        var item = _ref2.item;
        return [_vm._v(" " + _vm._s(_vm.$t("report.accidentDetails.location.".concat(item))) + " ")];
      }
    }]),
    model: {
      value: _vm.value.isDeductions,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "isDeductions", $$v);
      },
      expression: "value.isDeductions"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-select', {
    attrs: {
      "label": _vm.$t('objects.report.isDepreciationCredit'),
      "items": [true, false],
      "outlined": "",
      "readonly": _vm.readonly,
      "clearable": ""
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function fn(_ref3) {
        var item = _ref3.item;
        return [_c('v-chip', {
          attrs: {
            "small": ""
          }
        }, [_vm._v(" " + _vm._s(_vm.$t("report.accidentDetails.location.".concat(item))) + " ")])];
      }
    }, {
      key: "item",
      fn: function fn(_ref4) {
        var item = _ref4.item;
        return [_vm._v(" " + _vm._s(_vm.$t("report.accidentDetails.location.".concat(item))) + " ")];
      }
    }]),
    model: {
      value: _vm.value.isDepreciationCredit,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "isDepreciationCredit", $$v);
      },
      expression: "value.isDepreciationCredit"
    }
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }